export default __webpack_public_path__ + "static/media/deviare-logo-light.5ae567df.svg";